export const FETCH_EWO_DISCRIPENCY_REQUEST = "FETCH_EWO_DISCRIPENCY_REQUEST";
export const FETCH_EWO_DISCRIPENCY_SUCCESS = "FETCH_EWO_DISCRIPENCY_SUCCESS";
export const FETCH_EWO_DISCRIPENCY_FAILURE = "FETCH_EWO_DISCRIPENCY_FAILURE";